import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { BaseDialog } from 'components'
import { SharedCollectedFieldsFormModal } from './'

import * as service from 'service'
import helpers from 'helpers'
import useSnackbar from 'hooks/useSnackbar'

const SharedCollectedFieldsModal = ({
  sharedCollectedField,
  mode,
  dataProcessId,
  dataTreatmentId,
  open,
  onClose,
  onSuccess,
  deferSubmit = false,
}) => {
  const [loading, setLoading] = useState(false)
  const snackbar = useSnackbar()

  const dialogTitle =
    mode === 'edit'
      ? 'Editar dados compartilhados'
      : mode === 'show'
      ? 'Visualizar dados compartilhados'
      : 'Adicionar dados compartilhados'
  const actionButtonText = mode === 'show' ? '' : 'Salvar'
  const successMessageLabel = mode === 'edit' ? 'atualizados' : 'criados'

  const submitSuccess = async (newField) => {
    try {
      if (deferSubmit) {
        // Em modo de criação, apenas guardar na memória
        onSuccess(newField)
        onClose()
        return
      }

      setLoading(true)

      const payload = {
        sharedCollectedFieldsIds: newField.collectedFields?.map(
          (field) => field.id,
        ),
      }

      if (mode === 'edit') {
        await service.dponet.sharedCollectedFields.manage({
          dataProcessId,
          dataTreatmentId,
          sharedCollectedField: {
            ...payload,
            titularCategoryId: newField.titularCategory?.id,
          },
        })
      } else {
        await service.dponet.sharedCollectedFields.create({
          dataProcessId,
          dataTreatmentId,
          sharedCollectedField: payload,
        })
      }

      snackbar.open({
        message: `Dados compartilhados ${successMessageLabel} com sucesso`,
        variant: 'success',
      })
      if (onSuccess) onSuccess()
      onClose()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error) ||
          'Ocorreu algum erro! Tente novamente!',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={onClose}
      dialogSize="md"
      title={dialogTitle}
      closeButtonText="Voltar"
      actionButtonText={actionButtonText}
      formRef="shared-data-form"
      fullWidth
      loading={loading}
    >
      <SharedCollectedFieldsFormModal
        sharedCollectedField={sharedCollectedField}
        mode={mode}
        submitSuccess={submitSuccess}
      />
    </BaseDialog>
  )
}

SharedCollectedFieldsModal.propTypes = {
  sharedCollectedField: PropTypes.object,
  mode: PropTypes.string,
  dataProcessId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dataTreatmentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  deferSubmit: PropTypes.bool,
}

export default SharedCollectedFieldsModal
